export default "__VITE_ASSET__84cfdada__"